import React, { useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../context/firebase';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';
import './Calendar.css';
import Paper from '@material-ui/core/Paper';
import { ViewState } from '@devexpress/dx-react-scheduler';
import {
	Scheduler,
	DayView,
	Appointments,
	AppointmentTooltip,
	AppointmentForm,
	WeekView,
	MonthView,
	ViewSwitcher,
	Toolbar,
	DateNavigator,
	TodayButton,
} from '@devexpress/dx-react-scheduler-material-ui';
import {
	CircularProgress,
	darken,
	fade,
	FormControlLabel,
	lighten,
	makeStyles,
	Radio,
	RadioGroup,
	TextField,
	Typography,
	withStyles,
} from '@material-ui/core';
import { ColorLens, Person } from '@material-ui/icons';
import PhoneIcon from '@material-ui/icons/Phone';
import PersonIcon from '@material-ui/icons/Person';
import DraftsIcon from '@material-ui/icons/Drafts';
import CloseIcon from '@material-ui/icons/Close';
import createTypography from '@material-ui/core/styles/createTypography';
import { useHistory } from 'react-router';

function Calendar() {
	const [schedulerData, setSchedulerData] = useState();
	const { firebase } = useContext(FirebaseContext);
	const [currentViewName, setCurrentViewName] = useState();
	const [toolTipData, setToolTipData] = useState();
	const history = useHistory();
	const [loading, setLoading] = useState(false);

	const [formData, setFormData] = useState({
		notes: '',
	});

	const { notes } = formData;
	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	useEffect(() => {
		var currentTime = new Date();

		//current time test log
		console.log('This is the current time: ' + currentTime);

		firebase.auth().onAuthStateChanged(function (user) {
			if (user) {
				var currentUserId = firebase.auth().currentUser.uid;
				var appointmentsRef = firebase
					.database()
					.ref('/client_appointments/' + PROJECT_CODE.projectCode);
				appointmentsRef
					.orderByChild('createrID')
					.equalTo(currentUserId)
					.on('value', (snapshot) => {
						var appointments = [];
						var appCode;
						snapshot.forEach((element) => {
							var elementTime = element.val().timeOfAppointment;
							var elementTime30minAfter = elementTime + 1800000;
							var timeFormat = new Date(elementTime);
							var endTimeFormat = new Date(elementTime30minAfter);
							var usersRef = element.child('users');
							var fullName;
							var userEmail;
							var userPhone;
							var notes;
							var appName = element.val().appointmentName;
							appCode = element.val().appointmentID;
							var currentUserType;
							var currentUserId = firebase.auth().currentUser.uid;
							var shortcode = element.val().shortCode;

							console.log('shortcode: ' + shortcode);

							firebase
								.database()
								.ref('/users/' + currentUserId + '/userType')
								.on('value', function (snapshot) {
									currentUserType = snapshot.val();
								});

							usersRef.forEach((userDetail) => {
								fullName = userDetail.val().fullName;
								userEmail = userDetail.val().email;
								userPhone = userDetail.val().phoneNumber;
								notes = userDetail.val().notes;
							});

							console.log('fullName: ' + fullName);

							var timeFormatBuild =
								dayjs(timeFormat).format('YYYY-MM-DDTHH:mm');

							var endTimeFormatBuild =
								dayjs(endTimeFormat).format('YYYY-MM-DDTHH:mm');

							var scheduleData = {
								startDate: timeFormatBuild,
								endDate: endTimeFormatBuild,
								title: `Meeting with ${fullName}`,
								fullName: fullName,
								email: userEmail,
								notes: notes,
								phoneNumber: userPhone,
								appTime: elementTime,
								appName: appName,
								appCode: appCode,
								currentUserId: currentUserId,
								currentUserType: currentUserType,
								shortcode: shortcode,
							};

							console.log(JSON.stringify(scheduleData));

							console.log('These are the times: ' + timeFormatBuild);
							appointments.push(scheduleData);
						});
						console.log('These are the appts: ' + JSON.stringify(appointments));

						var newAppointments = appointments.filter(
							(item) =>
								!item.title.includes('Meeting with null') &&
								!item.title.includes('Meeting with undefined')
						);

						setSchedulerData(newAppointments);
					});
			}
		});
	}, []);

	const ExternalViewSwitcher = ({ currentViewName, onChange }) => (
		<RadioGroup
			aria-label='Views'
			style={{ flexDirection: 'row' }}
			name='views'
			value={currentViewName}
			onChange={onChange}
			className={styles.radioGroup}
		>
			<FormControlLabel
				value='Month'
				control={<Radio className={styles.radioBtn} />}
				label='Month'
				className={styles.radioLabel}
			/>
			<FormControlLabel
				value='Week'
				control={<Radio className={styles.radioBtn} />}
				label='Week'
				className={styles.radioLabel}
			/>
			<FormControlLabel
				value='Day'
				control={<Radio className={styles.radioBtn} />}
				label='Day'
				className={styles.radioLabel}
			/>
		</RadioGroup>
	);

	const currentViewNameChange = (e) => {
		console.log('current view name: ' + e.target.value);
		setCurrentViewName(e.target.value);
	};

	const currentDate = dayjs(new Date()).format('YYYY-MM-DDTHH:mm');

	console.log(JSON.stringify(schedulerData));

	const useStyles = makeStyles({
		radioGroup: {
			justifyContent: 'flex-end',
			marginBottom: '-50px',
		},
		radioBtn: {
			display: 'none',
		},
		radioLabel: {
			border: '1px solid #c7c7c7',
			padding: ' 2px 20px',
			marginTop: '30px',
			zIndex: '1',

			'&:hover': {
				backgroundColor: '#c7c7c7',
			},
		},
		dateNavigator: {
			backgroundColor: 'red',
		},
		tooltipPaper: {
			paddingBottom: '10px',
			position: 'relative',
		},
		tooltipIcon: {
			color: '#999999',
		},
		tooltipCloseBtn: {
			position: 'absolute',
			top: '8px',
			right: '0',
		},
		notesInput: {
			height: 100,
			width: '100%',
		},
		notesTextField: {
			width: '100%',
		},
	});

	const styles = useStyles();

	const Appointment = ({ children, style, data, ...restProps }) => (
		<Appointments.Appointment
			{...restProps}
			style={{
				...style,
				borderRadius: '5px',
			}}
			onClick={(e) => {
				setToolTipData(data);
				console.log('setToolTipData: ' + JSON.stringify(data));
				setFormData({ notes: data?.notes ? data?.notes : ""});
			}}
		>
			{children}
		</Appointments.Appointment>
	);

	const handleVideoCall = (e) => {
		setLoading(true);
		var detailsForCall = {
			thisEmail: toolTipData?.email,
			thisName: toolTipData?.appName,
			thisAppointmentCode: toolTipData?.appCode,
			thisAppointmentTime: toolTipData?.appTime,
			thisUserType: toolTipData?.currentUserType,
			thisPhone: toolTipData?.phoneNumber,
			thisUID: toolTipData?.currentUserId,
			shortCode: toolTipData?.shortcode,
		};

		console.log('DETAILS FOR CALL ' + JSON.stringify(detailsForCall));

		if (toolTipData !== undefined && notes !== undefined) {
			console.log('This is the note: ' + notes);
			var appointmentsRef = firebase
				.database()
				.ref(
					'/client_appointments/' +
						PROJECT_CODE.projectCode +
						'/' +
						toolTipData?.appCode +
						'/users/0'
				);

			appointmentsRef.update({
				notes: notes,
			});
		}

		history.push({
			pathname: '/videocall',
			state: {
				detail: detailsForCall,
			},
		});
		setLoading(false);
	};

	const handleCancel = () => {
		var deleteKey = toolTipData?.appCode;

		if (window.confirm('Do you really want to cancel an appointment?')) {
			var newDeleteRef = firebase
				.database()
				.ref('/client_appointments/' + PROJECT_CODE.projectCode)
				.child(deleteKey);

			newDeleteRef.remove();
			setToolTipData();
		}
	};

	const handleCloseTooltip = () => {
		console.log('apCode: ' + toolTipData?.appCode);
		if (toolTipData !== undefined && notes !== undefined) {
			var appointmentsRef = firebase
				.database()
				.ref(
					'/client_appointments/' +
						PROJECT_CODE.projectCode +
						'/' +
						toolTipData?.appCode +
						'/users/0'
				);

			console.log('handleCloseToolTip: ' + toolTipData?.appCode);

			appointmentsRef.update({
				notes: notes,
			});
		}
		setToolTipData();
	};

	return (
		<>
			{loading && (
				<div className='loading_layout_videocall'>
					<div className='inner_loading_layout'>
						<CircularProgress className='circular-load' />
						<div className='authenticate-text'>
							<p>Authenticating...</p>
						</div>
					</div>
				</div>
			)}
			<div className='calendarPage'>
				<h2 id='calendar-title'>Calendar</h2>

				<div className='flex-calendar'>
					<Paper className='calendarContainer'>
						<Scheduler data={schedulerData} className='calender-comp'>
							<ViewState
								defaultCurrentDate={currentDate}
								currentViewName={currentViewName}
							/>
							<MonthView />
							<DayView startDayHour={7} endDayHour={20} />
							<WeekView startDayHour={7} endDayHour={20} />

							<Appointments appointmentComponent={Appointment} />

							<Toolbar />

							<ExternalViewSwitcher
								currentViewName={currentViewName}
								onChange={(e) => currentViewNameChange(e)}
							/>
							<TodayButton />
							<DateNavigator />
							<AppointmentTooltip showCloseButton />
							<AppointmentForm readOnly />
						</Scheduler>
					</Paper>

					{toolTipData && (
						<div className='appointment-detail'>
							{console.log(
								'THis is the tooldtuip data: ' + JSON.stringify(toolTipData)
							)}
							<Paper className={styles.tooltipPaper}>
								<div onClick={handleCloseTooltip}>
									<CloseIcon className={styles.tooltipCloseBtn} />
								</div>
								<h2 className='tooltip-title'>Meeting Details</h2>
								<div className='tooltip-field'>
									<Person className={styles.tooltipIcon} />
									<p className='tooltip-label'>{toolTipData?.fullName}</p>
								</div>
								<div className='tooltip-field'>
									<DraftsIcon className={styles.tooltipIcon} />
									<p className='tooltip-label'>{toolTipData?.email}</p>
								</div>
								<div className='tooltip-field'>
									<PhoneIcon className={styles.tooltipIcon} />
									<p className='tooltip-label'>{toolTipData?.phoneNumber}</p>
								</div>
								<div className='tooltip-notes-field'>
									<TextField
										placeholder='Notes'
										name='notes'
										value={notes}
										onChange={(e) => onChange(e)}
										className={styles.notesTextField}
										InputProps={{ classes: { input: styles.notesInput } }}
									/>
								</div>
								<div className='tooltip-actions'>
									<button className='tooltip-join' onClick={handleVideoCall}>
										Join
									</button>
									<button className='tooltip-cancel' onClick={handleCancel}>
										Cancel
									</button>
								</div>
							</Paper>
						</div>
					)}
				</div>
			</div>
		</>
	);
}

export default Calendar;
